// @ts-nocheck
import React from 'react';
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, Card, Box, ModalCloseButton } from '@chakra-ui/react';

const LevelModal = ({ isOpen, onClose, onNextLevel, onReplay, isManual }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
       p={2}
       borderRadius="10px"
       bg="white"
       width="150px"
       height="300px"
       className="custom-modal">
        <Box>
        <Card className='card' width="150px" height="300px" border={"1px solid white"} p={5} borderRadius={"10px"}>
          
        <Card p={1}  width={'150px'} height={'300px'} bgColor={"white"} borderRadius={"10px"}>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'  }}>
        <ModalCloseButton color="red"  width={"90%"}/></div>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'  }}>
          
        <ModalHeader flex={1} textAlign="center" color="blue.500">
          {isManual ? "Level Select" : "Level Cleared!"}</ModalHeader>
          
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'  }}>
          <br/>
        <ModalBody color="blue.500" fontSize={"11px"} fontStyle={"italic"}>
          {isManual 
            ? "Choose your next action."
            : "Congratulations! You've cleared the level."}
        </ModalBody>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'  }}>
        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={onNextLevel}>
            {isManual ? "Start Level" : "Next Level"}
          </Button>
          <Button variant="ghost" onClick={onReplay}>Replay</Button>
        </ModalFooter>
        
        </div>
        </Card>
     
        </Card>
        </Box>
      </ModalContent>
    </Modal>
  );
};

export default LevelModal;
